import { getWxShareInfo } from '@/api/wxShare'

import wx from 'weixin-js-sdk'

export const weiXinShare = (link) => {
  getWxShareInfo({ url: window.location.origin + link })
    .then(res => {
      if (res.data.code === 200) {
        // 配置微信信息
        wx.config({
          // debug : true, // true:调试时候弹窗
          appId: res.data.data.appId, // 微信appid
          timestamp: res.data.data.timestamp, // 时间戳
          nonceStr: res.data.data.nonceStr, // 随机字符串
          signature: res.data.data.signature, // 签名
          jsApiList: [
            // 所有要调用的 API 都要加到这个列表中
            'onMenuShareTimeline', // 分享到朋友圈接口
            'onMenuShareAppMessage', // 分享到朋友接口
            'onMenuShareQQ', // 分享到QQ接口
            'onMenuShareQZone', // 分享到QQ空间
            'onMenuShareWeibo', // 分享到微博接口
            'hideMenuItems'
          ]
        })
        wx.ready(function () {
          let env = process.env.NODE_ENV
          let urls = {
            'production': 'https://edu.turingapi.com',
            'beta': 'https://edu-beta.turingapi.com',
            'alpha': 'https://edu-alpha.turingapi.com',
            'development': 'https://edu-alpha.turingapi.com'
          }
          let imgUrl = `${urls[env]}/img/share.jpg`
          // 微信分享的数据
          var shareData = {
            // 'imgUrl': `http://edu-alpha.turingapi.com/img/share.jpg`, // 分享显示的缩略图地址
            'imgUrl': imgUrl, // 分享显示的缩略图地址
            // 'imgUrl': '../assets/images/share.jpg',
            'link': `${urls[env]}/share`,
            'desc': '智能教育、快乐成长', // 分享描述
            'title': '智娃陪读', // 分享标题
            success: function () {
              // 分享成功可以做相应的数据处理
              // let data = orderId
              // this.$router.push({ name: 'checkstand', query: { data } })
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              // alert("分享取消22");
              // let data = orderId
              // this.$router.push({ name: 'checkstand', query: { data } })
            }
          }

          wx.hideMenuItems({
            menuList: ['menuItem:copyUrl'], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            success: function (res) {
              // alert("隐藏")
            }
          })

          wx.onMenuShareTimeline(shareData)
          wx.onMenuShareAppMessage(shareData)
          wx.onMenuShareQQ(shareData)
          wx.onMenuShareQZone(shareData)
          wx.onMenuShareWeibo(shareData)
        })
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，
          // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
          // 对于SPA可以在这里更新签名。
          // alert('好像出错了！')
          console.log('好像出错了！')
        })
      } else {
        this.$toast('获取微信配置失败!')
      }
    })
}
